import { Tabs, Tab } from 'react-bootstrap';
import DefaultLayout from '../../../components/Layouts/DefaultLayout';
import Filter from '../components/Filter';
import { Box } from '@mui/system';
import DataTable from '../components/DataTable';
import '../styles.css';

const IncomeStatementV1Screen = ({ tableData, params, onFilter, onExport }) => {
  return (
    <DefaultLayout title="Income Statement">
      <Tabs id="controlled-tab-example" className="default-tab">
        <Tab
          className="default-tab-content"
          eventKey="income_statement"
          title="Income Statement"
        >
          <Box className="mb-3">
            <Filter onFilter={onFilter} onExport={onExport} />
          </Box>
          <DataTable
            data={tableData.data}
            isLoading={tableData.loading}
            headers={tableData.headers}
            dateFields={tableData.dateFields}
            params={params}
          />
        </Tab>
      </Tabs>
    </DefaultLayout>
  );
};

export default IncomeStatementV1Screen;
